// Language translations for Employee Access (Mobile)
export const translations = {
  en: {
    // Header
    employeeTimesheet: "Employee Timesheet",
    selectLanguage: "Language",
    
    // Employee Selection
    selectEmployee: "Select Employee",
    searchEmployee: "Search employee...",
    
    // Work Order Selection
    selectWorkOrder: "Select Work Order",
    searchWorkOrder: "Search work order...",
    
    // Machine Selection
    selectMachine: "Select Machine",
    
    // Buttons
    startWork: "Start Work",
    stopWork: "Stop Work",
    confirmStop: "Confirm & Stop",
    cancel: "Cancel",
    submit: "Submit",
    save: "Save",
    
    // Status
    activeEmployees: "Active Employees",
    noActiveEmployees: "No active employees",
    workingOn: "Working on",
    startedAt: "Started at",
    duration: "Duration",
    
    // Production Counts
    enterProductionCounts: "Enter Production Counts",
    sheetCounting: "Sheet Counting",
    paperCounting: "Paper Counting",
    boardCounting: "Board Counting",
    boxesCounting: "Boxes Counting",
    balanceReelWeight: "Balance Reel Weight",
    
    // Material Tracking
    materialTracking: "Material Tracking",
    reelId: "Reel ID",
    usedWeight: "Used Weight",
    balanceWeight: "Balance Weight",
    
    // Messages
    workStarted: "Work started successfully",
    workStopped: "Work stopped successfully",
    error: "Error",
    success: "Success",
    
    // Process Names
    corrugation: "Corrugation",
    sheetCutting: "Sheet Cutting",
    paperCutting: "Paper Cutting",
    sheetPasting: "Sheet Pasting",
    thinBlade: "Thin Blade Slitter",
    rotaryCreasing: "4 Bar Rotary Creasing",
    printing: "RS4 Printing & Slotting",
    flatBedPunching: "Flat Bed Punching",
    rotaryDiePunching: "Rotary Die Punching",
    calicoPasting: "Calico Pasting",
    stitching: "Stitching & Bundling",
    loading: "Loading / Unloading",
    transport: "Transport",
    
    // Misc
    kg: "Kg",
    pieces: "pcs",
    hours: "hrs",
    minutes: "min",
  },
  
  ta: {
    // Header
    employeeTimesheet: "பணியாளர் நேர பதிவு",
    selectLanguage: "மொழி",
    
    // Employee Selection
    selectEmployee: "பணியாளரை தேர்ந்தெடுக்கவும்",
    searchEmployee: "பணியாளரை தேடு...",
    
    // Work Order Selection
    selectWorkOrder: "பணி ஆர்டரை தேர்ந்தெடுக்கவும்",
    searchWorkOrder: "பணி ஆர்டரை தேடு...",
    
    // Machine Selection
    selectMachine: "இயந்திரத்தை தேர்ந்தெடுக்கவும்",
    
    // Buttons
    startWork: "பணி தொடங்கு",
    stopWork: "பணி நிறுத்து",
    confirmStop: "உறுதிப்படுத்தி நிறுத்து",
    cancel: "ரத்து செய்",
    submit: "சமர்ப்பி",
    save: "சேமி",
    
    // Status
    activeEmployees: "செயலில் உள்ள பணியாளர்கள்",
    noActiveEmployees: "செயலில் உள்ள பணியாளர்கள் இல்லை",
    workingOn: "பணிபுரியும் இயந்திரம்",
    startedAt: "தொடங்கிய நேரம்",
    duration: "கால அளவு",
    
    // Production Counts
    enterProductionCounts: "உற்பத்தி எண்ணிக்கையை உள்ளிடவும்",
    sheetCounting: "தாள் எண்ணிக்கை",
    paperCounting: "காகித எண்ணிக்கை",
    boardCounting: "போர்டு எண்ணிக்கை",
    boxesCounting: "பெட்டி எண்ணிக்கை",
    balanceReelWeight: "மீதமுள்ள ரீல் எடை",
    
    // Material Tracking
    materialTracking: "பொருள் கண்காணிப்பு",
    reelId: "ரீல் ஐடி",
    usedWeight: "பயன்படுத்திய எடை",
    balanceWeight: "மீதமுள்ள எடை",
    
    // Messages
    workStarted: "பணி வெற்றிகரமாக தொடங்கப்பட்டது",
    workStopped: "பணி வெற்றிகரமாக நிறுத்தப்பட்டது",
    error: "பிழை",
    success: "வெற்றி",
    
    // Process Names
    corrugation: "சுருள் இயந்திரம்",
    sheetCutting: "தாள் வெட்டுதல்",
    paperCutting: "காகித வெட்டுதல்",
    sheetPasting: "தாள் ஒட்டுதல்",
    thinBlade: "மெல்லிய பிளேடு",
    rotaryCreasing: "சுழல் மடிப்பு",
    printing: "அச்சிடுதல்",
    flatBedPunching: "தட்டை துளையிடுதல்",
    rotaryDiePunching: "சுழல் துளையிடுதல்",
    calicoPasting: "கலிகோ ஒட்டுதல்",
    stitching: "தையல் & கட்டுதல்",
    loading: "ஏற்றுதல் / இறக்குதல்",
    transport: "போக்குவரத்து",
    
    // Misc
    kg: "கிலோ",
    pieces: "துண்டுகள்",
    hours: "மணி",
    minutes: "நிமிடம்",
  },
  
  hi: {
    // Header
    employeeTimesheet: "कर्मचारी समय पत्रक",
    selectLanguage: "भाषा",
    
    // Employee Selection
    selectEmployee: "कर्मचारी चुनें",
    searchEmployee: "कर्मचारी खोजें...",
    
    // Work Order Selection
    selectWorkOrder: "कार्य आदेश चुनें",
    searchWorkOrder: "कार्य आदेश खोजें...",
    
    // Machine Selection
    selectMachine: "मशीन चुनें",
    
    // Buttons
    startWork: "काम शुरू करें",
    stopWork: "काम बंद करें",
    confirmStop: "पुष्टि करें और रोकें",
    cancel: "रद्द करें",
    submit: "जमा करें",
    save: "सहेजें",
    
    // Status
    activeEmployees: "सक्रिय कर्मचारी",
    noActiveEmployees: "कोई सक्रिय कर्मचारी नहीं",
    workingOn: "काम कर रहे हैं",
    startedAt: "शुरू किया",
    duration: "अवधि",
    
    // Production Counts
    enterProductionCounts: "उत्पादन गणना दर्ज करें",
    sheetCounting: "शीट गणना",
    paperCounting: "कागज गणना",
    boardCounting: "बोर्ड गणना",
    boxesCounting: "बक्से गणना",
    balanceReelWeight: "शेष रील वजन",
    
    // Material Tracking
    materialTracking: "सामग्री ट्रैकिंग",
    reelId: "रील आईडी",
    usedWeight: "उपयोग किया गया वजन",
    balanceWeight: "शेष वजन",
    
    // Messages
    workStarted: "काम सफलतापूर्वक शुरू हुआ",
    workStopped: "काम सफलतापूर्वक रुका",
    error: "त्रुटि",
    success: "सफलता",
    
    // Process Names
    corrugation: "कोरूगेशन",
    sheetCutting: "शीट काटना",
    paperCutting: "कागज काटना",
    sheetPasting: "शीट चिपकाना",
    thinBlade: "पतली ब्लेड",
    rotaryCreasing: "रोटरी क्रीजिंग",
    printing: "प्रिंटिंग",
    flatBedPunching: "फ्लैट बेड पंचिंग",
    rotaryDiePunching: "रोटरी डाई पंचिंग",
    calicoPasting: "कैलिको चिपकाना",
    stitching: "सिलाई और बंडलिंग",
    loading: "लोडिंग / अनलोडिंग",
    transport: "परिवहन",
    
    // Misc
    kg: "किलो",
    pieces: "टुकड़े",
    hours: "घंटे",
    minutes: "मिनट",
  },
  
  or: {
    // Header (Odia/Oriya)
    employeeTimesheet: "କର୍ମଚାରୀ ସମୟ ପତ୍ର",
    selectLanguage: "ଭାଷା",
    
    // Employee Selection
    selectEmployee: "କର୍ମଚାରୀ ଚୟନ କରନ୍ତୁ",
    searchEmployee: "କର୍ମଚାରୀ ଖୋଜନ୍ତୁ...",
    
    // Work Order Selection
    selectWorkOrder: "କାର୍ଯ୍ୟ ଆଦେଶ ଚୟନ କରନ୍ତୁ",
    searchWorkOrder: "କାର୍ଯ୍ୟ ଆଦେଶ ଖୋଜନ୍ତୁ...",
    
    // Machine Selection
    selectMachine: "ମେସିନ୍ ଚୟନ କରନ୍ତୁ",
    
    // Buttons
    startWork: "କାମ ଆରମ୍ଭ କରନ୍ତୁ",
    stopWork: "କାମ ବନ୍ଦ କରନ୍ତୁ",
    confirmStop: "ନିଶ୍ଚିତ କରନ୍ତୁ ଏବଂ ବନ୍ଦ କରନ୍ତୁ",
    cancel: "ବାତିଲ୍ କରନ୍ତୁ",
    submit: "ଦାଖଲ କରନ୍ତୁ",
    save: "ସଞ୍ଚୟ କରନ୍ତୁ",
    
    // Status
    activeEmployees: "ସକ୍ରିୟ କର୍ମଚାରୀ",
    noActiveEmployees: "କୌଣସି ସକ୍ରିୟ କର୍ମଚାରୀ ନାହାଁନ୍ତି",
    workingOn: "କାମ କରୁଛନ୍ତି",
    startedAt: "ଆରମ୍ଭ ହେଲା",
    duration: "ସମୟକାଳ",
    
    // Production Counts
    enterProductionCounts: "ଉତ୍ପାଦନ ଗଣନା ଦାଖଲ କରନ୍ତୁ",
    sheetCounting: "ସିଟ୍ ଗଣନା",
    paperCounting: "କାଗଜ ଗଣନା",
    boardCounting: "ବୋର୍ଡ ଗଣନା",
    boxesCounting: "ବାକ୍ସ ଗଣନା",
    balanceReelWeight: "ଅବଶିଷ୍ଟ ରିଲ୍ ଓଜନ",
    
    // Material Tracking
    materialTracking: "ସାମଗ୍ରୀ ଟ୍ରାକିଂ",
    reelId: "ରିଲ୍ ଆଇଡି",
    usedWeight: "ବ୍ୟବହୃତ ଓଜନ",
    balanceWeight: "ଅବଶିଷ୍ଟ ଓଜନ",
    
    // Messages
    workStarted: "କାମ ସଫଳତାର ସହ ଆରମ୍ଭ ହେଲା",
    workStopped: "କାମ ସଫଳତାର ସହ ବନ୍ଦ ହେଲା",
    error: "ତ୍ରୁଟି",
    success: "ସଫଳତା",
    
    // Process Names
    corrugation: "କୋରୁଗେସନ୍",
    sheetCutting: "ସିଟ୍ କାଟିବା",
    paperCutting: "କାଗଜ କାଟିବା",
    sheetPasting: "ସିଟ୍ ଲଗାଇବା",
    thinBlade: "ପତଳା ବ୍ଲେଡ୍",
    rotaryCreasing: "ରୋଟାରୀ କ୍ରିଜିଂ",
    printing: "ପ୍ରିଣ୍ଟିଂ",
    flatBedPunching: "ଫ୍ଲାଟ୍ ବେଡ୍ ପଞ୍ଚିଂ",
    rotaryDiePunching: "ରୋଟାରୀ ଡାଏ ପଞ୍ଚିଂ",
    calicoPasting: "କାଲିକୋ ଲଗାଇବା",
    stitching: "ସିଲାଇ ଏବଂ ବନ୍ଧନ",
    loading: "ଲୋଡିଂ / ଅନଲୋଡିଂ",
    transport: "ପରିବହନ",
    
    // Misc
    kg: "କିଲୋ",
    pieces: "ଖଣ୍ଡ",
    hours: "ଘଣ୍ଟା",
    minutes: "ମିନିଟ୍",
  }
};

export const languageNames = {
  en: "English",
  ta: "தமிழ்",
  hi: "हिन्दी",
  or: "ଓଡ଼ିଆ"
};

export default translations;
